<div class="box">
  <app-event-type-setting></app-event-type-setting>
</div>